import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';

import { useUISize } from 'app/utils/web-helpers';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export function TrialBanner({
  freeSubAvailable,
  freeSubNumDaysLeft,
  onSubscribe,
}: {
  freeSubAvailable: string;
  freeSubNumDaysLeft: number;
  onSubscribe: () => void;
}) {
  const { t } = useTranslation('all-listings');
  const { isLargeUI } = useUISize();
  return (
    <Column
      gap="spacing.general.x2"
      padding="spacing.general.x4"
      style={{
        backgroundColor: theme.colors['surface.inverse.tertiary-neutral'],
        borderRadius: theme.borderRadii['radius.lg'],
        alignItems: isLargeUI ? 'center' : 'flex-start',
      }}
    >
      <Text fontSize={13} variant="bodyBase">
        <Trans
          components={{ strong: <Text fontWeight="600" /> }}
          i18nKey={`promoFreeSub.${freeSubAvailable}.text${freeSubNumDaysLeft <= 1 ? '1' : ''}`}
          ns="all-listings"
          values={{ numDays: freeSubNumDaysLeft }}
        />
      </Text>
      <Button onPress={onSubscribe} variant="primary" style={{ alignSelf: isLargeUI ? 'center' : 'stretch' }}>
        <Text color="surface.default" fontWeight="600">
          {t('promoFreeSub.subscribeButton', { defaultValue: "S'abonner maintenant" })}
        </Text>
      </Button>
    </Column>
  );
}
